import * as luckyXTranslationsPackage from '@nsftx/i18n-lucky-x';

export default {
  name: 'luckyx',
  translationPackage: luckyXTranslationsPackage,
};
